import { intersection } from "lodash";

export const taskMatchesFilters = (task, filters) => {
    return (
        taskMatchesStatusFilter(task, filters) &&
        taskMatchesPriorityFilter(task, filters) &&
        taskMatchesScheduledForFilter(task, filters) &&
        taskMatchesAssigneesFilter(task, filters) &&
        taskMatchesCategoryFilter(task, filters) &&
        taskMatchesSpacesOrAssetsFilter(task, filters)
    );
};

const taskMatchesStatusFilter = (task, filters) => {
    const statuses = filters?.statuses;

    if (!statuses || statuses.length === 0) {
        return true;
    }

    return statuses.includes(task.status);
};

const taskMatchesPriorityFilter = (task, filters) => {
    const priorities = filters?.priorities;

    if (!priorities || priorities.length === 0) {
        return true;
    }

    return priorities.includes(task.priority.id);
};

const taskMatchesScheduledForFilter = (task, filters) => {
    const scheduled_for = filters?.scheduled_for;

    if (!scheduled_for?.gte || !scheduled_for?.lte) {
        return true;
    }

    const taskScheduledFor = new Date(task.scheduled_for);
    const startDate = new Date(scheduled_for.gte);
    const endDate = new Date(scheduled_for.lte);

    return taskScheduledFor >= startDate && taskScheduledFor <= endDate;
};

const taskMatchesAssigneesFilter = (task, filters) => {
    const assignees = filters?.assignees;

    if (!assignees || assignees?.length === 0) {
        return true;
    }

    const taskAssignees = task.assignees.map((a) => a.id);

    return intersection(taskAssignees, assignees).length > 0;
};

const taskMatchesCategoryFilter = (task, filters) => {
    const categories = filters?.categories;

    if (!categories || categories?.length === 0) {
        return true;
    }

    return categories.includes(task.category?.id);
};

const taskMatchesSpacesOrAssetsFilter = (task, filters) => {
    const children = [...(filters?.spaces || []), ...(filters?.assets || [])];

    if (children.length === 0) {
        return true;
    }

    return children.includes(task.space?.id);
};
